import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Lock, User, ArrowRight, Phone } from 'lucide-react';
export function CreateAccount() {
  return <div className="min-h-[calc(100vh-200px)] bg-gradient-to-br from-gray-900 via-[#0E578E] to-gray-900 flex items-center justify-center py-16 px-4 sm:px-6 lg:px-8 relative overflow-hidden" data-id="element-727">
      {/* Animated Background Pattern */}
      <div className="absolute inset-0 opacity-10" data-id="element-728">
        <div className="absolute top-1/4 left-1/4 w-96 h-96 bg-[#01AAE7] rounded-full blur-3xl animate-pulse" data-id="element-729"></div>
        <div className="absolute bottom-1/4 right-1/4 w-96 h-96 bg-white rounded-full blur-3xl animate-pulse" style={{
        animationDelay: '1s'
      }} data-id="element-730"></div>
      </div>

      {/* Diagonal Lines Pattern */}
      <div className="absolute inset-0 opacity-5" style={{
      backgroundImage: `repeating-linear-gradient(45deg, transparent, transparent 35px, rgba(255,255,255,.1) 35px, rgba(255,255,255,.1) 70px)`
    }} data-id="element-731"></div>

      <div className="max-w-md w-full relative z-10" data-id="element-732">
        {/* Header */}
        <div className="text-center mb-8" data-id="element-733">
          <h2 className="text-4xl font-black text-white mb-2" data-id="element-734">
            Join RaceLookup
          </h2>
          <p className="text-white/80 text-lg" data-id="element-735">
            Start your running journey today
          </p>
        </div>

        {/* Create Account Card */}
        <div className="bg-white/95 backdrop-blur-xl rounded-3xl shadow-2xl p-8 border border-white/20" data-id="element-736">
          <form className="space-y-5" data-id="element-737">
            {/* First Name */}
            <div data-id="element-738">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-739">
                First Name
              </label>
              <input type="text" placeholder="First name" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-740" />
            </div>

            {/* Last Name */}
            <div data-id="element-741">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-742">
                Last Name
              </label>
              <input type="text" placeholder="Last name" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-743" />
            </div>

            {/* Phone Number */}
            <div data-id="element-744">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-745">
                Phone Number
              </label>
              <input type="tel" placeholder="Format: xxx-xxx-xxxx" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-746" />
            </div>

            {/* Email */}
            <div data-id="element-747">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-748">
                Email
              </label>
              <input type="email" placeholder="xyz@gmail.com" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-749" />
            </div>

            {/* Username */}
            <div data-id="element-750">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-751">
                Username
              </label>
              <input type="text" placeholder="User name" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-752" />
            </div>

            {/* Password */}
            <div data-id="element-753">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-754">
                Password
              </label>
              <input type="password" placeholder="••••••••" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-755" />
            </div>

            {/* Confirm Password */}
            <div data-id="element-756">
              <label className="block text-sm font-bold text-gray-700 mb-2" data-id="element-757">
                Confirm Password
              </label>
              <input type="password" placeholder="••••••••" className="w-full px-4 py-3 bg-gray-50 border-2 border-gray-200 rounded-xl focus:outline-none focus:border-[#01AAE7] focus:bg-white text-gray-900 transition-all" data-id="element-758" />
            </div>

            {/* Monthly Newsletter Checkbox */}
            <div className="pt-2" data-id="element-759">
              <label className="flex items-start gap-3 cursor-pointer group" data-id="element-760">
                <input type="checkbox" className="w-5 h-5 mt-0.5 rounded border-2 border-gray-300 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer flex-shrink-0" data-id="element-761" />
                <span className="text-sm text-gray-700 leading-relaxed" data-id="element-762">
                  I would like to receive information, tips, and offers about
                  RaceLookup products and services.
                </span>
              </label>
            </div>

            {/* Radio Button Questions */}
            <div className="space-y-4 pt-2" data-id="element-763">
              {/* Free Trial Question */}
              <div data-id="element-764">
                <p className="text-sm font-bold text-gray-900 mb-3" data-id="element-765">
                  Would you like to add a free one-year trial membership to
                  Racelookup TRAVEL, a $9.99 value?
                </p>
                <div className="flex items-center gap-6" data-id="element-766">
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-767">
                    <input type="radio" name="travel-trial" defaultChecked className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-768" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-769">
                      Yes
                    </span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-770">
                    <input type="radio" name="travel-trial" className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-771" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-772">
                      No
                    </span>
                  </label>
                </div>
              </div>

              {/* Business Profile Question */}
              <div data-id="element-773">
                <p className="text-sm font-bold text-gray-900 mb-3" data-id="element-774">
                  Would you like to add a business profile to your online
                  account?
                </p>
                <div className="flex items-center gap-6" data-id="element-775">
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-776">
                    <input type="radio" name="business-profile" className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-777" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-778">
                      Yes
                    </span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-779">
                    <input type="radio" name="business-profile" defaultChecked className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-780" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-781">
                      No
                    </span>
                  </label>
                </div>
              </div>

              {/* Pacer Profile Question */}
              <div data-id="element-782">
                <p className="text-sm font-bold text-gray-900 mb-3" data-id="element-783">
                  Would you like to create a pacer profile and be added to a
                  searchable list to become a pacer?
                </p>
                <div className="flex items-center gap-6" data-id="element-784">
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-785">
                    <input type="radio" name="pacer-profile" className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-786" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-787">
                      Yes
                    </span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-788">
                    <input type="radio" name="pacer-profile" defaultChecked className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-789" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-790">
                      No
                    </span>
                  </label>
                </div>
              </div>

              {/* Volunteer Profile Question */}
              <div data-id="element-791">
                <p className="text-sm font-bold text-gray-900 mb-3" data-id="element-792">
                  Would you like to create a volunteer profile and be added to a
                  searchable list to become a volunteer?
                </p>
                <div className="flex items-center gap-6" data-id="element-793">
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-794">
                    <input type="radio" name="volunteer-profile" className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-795" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-796">
                      Yes
                    </span>
                  </label>
                  <label className="flex items-center gap-2 cursor-pointer group" data-id="element-797">
                    <input type="radio" name="volunteer-profile" defaultChecked className="w-5 h-5 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer" data-id="element-798" />
                    <span className="text-sm text-gray-700 font-medium" data-id="element-799">
                      No
                    </span>
                  </label>
                </div>
              </div>
            </div>

            {/* Terms Checkbox */}
            <div className="pt-2" data-id="element-800">
              <label className="flex items-start gap-3 cursor-pointer group" data-id="element-801">
                <input type="checkbox" className="w-5 h-5 mt-0.5 rounded border-2 border-gray-300 text-[#01AAE7] focus:ring-2 focus:ring-[#01AAE7] focus:ring-offset-0 cursor-pointer flex-shrink-0" data-id="element-802" />
                <span className="text-sm text-gray-700 leading-relaxed font-medium" data-id="element-803">
                  Accept Terms & Condition
                </span>
              </label>
            </div>

            {/* Create Account Button */}
            <button type="submit" className="group w-full bg-gradient-to-r from-[#01AAE7] to-[#0199d6] text-white font-bold py-4 px-6 rounded-xl hover:from-[#0199d6] hover:to-[#0188c5] transition-all shadow-lg hover:shadow-xl transform hover:-translate-y-0.5 flex items-center justify-center gap-2 relative overflow-hidden mt-6" data-id="element-804">
              <span className="relative z-10" data-id="element-805">Create Account</span>
              <ArrowRight className="h-5 w-5 relative z-10 transition-transform duration-300 group-hover:translate-x-1" data-id="element-806" />
              <div className="absolute inset-0 bg-gradient-to-r from-transparent via-white/20 to-transparent -translate-x-full group-hover:translate-x-full transition-transform duration-700" data-id="element-807"></div>
            </button>
          </form>

          {/* Sign In Link */}
          <div className="mt-6 text-center" data-id="element-808">
            <p className="text-sm text-gray-600" data-id="element-809">
              Already have an account?{' '}
              <Link to="/signin" className="font-bold text-[#01AAE7] hover:text-[#0E578E] transition-colors" data-id="element-810">
                Sign in
              </Link>
            </p>
          </div>
        </div>
      </div>
    </div>;
}